export const getCategoriesData = (store, route) => {
  let currentCategory = null;
  let parentCategory = null;
  const categories = store?.getters?.getCategories ?? [];
  const id = route?.params?.id;

  if (!id || !categories.length) {
    return { current: null, parent: null };
  }

  categories.forEach((category) => {
    if (category.id == id) {
      currentCategory = category;
    }
    (category.children || []).forEach((childCategory) => {
      if (childCategory.id == id) {
        currentCategory = childCategory;
        parentCategory = category;
      }
    });
  });

  return { current: currentCategory, parent: parentCategory };
};
